import Cursor from '@@types/Cursor';

import { EDITOR_ORIGIN } from '~/constants/editor';
import { stores } from '~/stores/Stores';
import { htmlEntityEncode } from '~/utils/textUtil/textUtil';

import { Hint } from './Hint';

class CommandMention implements Hint {
  name = 'commandMention';

  origin = EDITOR_ORIGIN.COMMAND_MENTION_COMPLETE;

  fromDistance = 1;

  get regex() {
    return stores.commandMentionRegex;
  }

  checkActive(text: string, cursor?: Cursor): boolean {
    return cursor.line === 0 && this.regex.test(text);
  }

  convertItemToText({
    name,
    defaultOrganizationId: orgId,
    id,
    tenantMemberRole: role,
  }: {
    name: string;
    defaultOrganizationId: string;
    id: string;
    tenantMemberRole: string;
  }) {
    return `[@${htmlEntityEncode(name)}](dooray://${orgId}/members/${id} "${role}") `;
  }

  getQuery(text: string): string {
    const result = this.regex.exec(text);
    return result ? result[1] : '';
  }
}

export default new CommandMention();
